import type { FC } from 'react';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button';

import { withRoutesContext } from '@confluence/route-manager';
import { getLoginLink } from '@confluence/login-if-anonymous/entry-points/getLoginLink';

import { useWithButtonAnalytics } from '../hooks/useWithButtonAnalytics';

export const LogInButton: FC<{
	contentId: string;
	renderLocation: string;
	contentType?: string | null;
}> = withRoutesContext(({ contentId, renderLocation, getHref, contentType }) => {
	const { sendButtonUIEvent } = useWithButtonAnalytics({
		actionSubjectId: 'logInToConfluenceButton',
		contentId,
		renderLocation,
		contentType,
	});
	const siteUrl = `${window.location.origin}${getHref()}`;

	return (
		<Button href={getLoginLink(siteUrl)} onClick={sendButtonUIEvent} appearance="link">
			<FormattedMessage
				id="external-share.log-in-to-confluence.button"
				description="button label text for a CTA to log in to Confluence"
				defaultMessage="Log in"
			/>
		</Button>
	);
});
